import { cn } from '@commenda/utils';
import React from 'react';

import { Button } from '../../Button';
import { Icons } from '../../Icons';
import { Tooltip } from '../../Tooltip';
import { DataGridAlign } from '../types';
import { getDataGridJustifyClass } from '../utils';

export interface DataGridCellLinkProps {
  children: React.ReactNode;
  onClick?: () => void;
  isDisabled?: boolean;
  tooltip?: React.ReactNode;
  leading?: React.ReactNode;
  align?: DataGridAlign;
  className?: string;
}

const DataGridCellLink = ({
  children,
  onClick,
  isDisabled,
  tooltip,
  leading,
  align = 'left',
  className,
}: DataGridCellLinkProps) => (
  <div
    className={cn(
      'flex w-full items-center gap-md',
      getDataGridJustifyClass(align),
      className
    )}
  >
    {leading}
    <Button
      variant="link"
      size="sm"
      onClick={onClick}
      disabled={isDisabled}
      className="min-w-0 truncate"
    >
      {children}
    </Button>
    {tooltip ? (
      <Tooltip content={tooltip} asChild>
        <span className="flex shrink-0 items-center">
          <Icons.InfoCircle className="size-4" />
        </span>
      </Tooltip>
    ) : null}
  </div>
);

export { DataGridCellLink };
